import { useRef } from "react";
import { CanvasDrawer } from "../../CanvasDrawer";
import { useStickerSectionStore } from "../../EditorStore";


export default function useTwoFingerPanAndZoom() {

    const lastDoubleTouchPos = useRef<null | { x: number, y: number }>(null)
    const lastDistanceBetweenTouches = useRef<null | number>(null)

    const twoFingerTouchStart = (e: React.TouchEvent<HTMLCanvasElement>) => {
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];

        const midpointX = (touch1.clientX + touch2.clientX) / 2;
        const midpointY = (touch1.clientY + touch2.clientY) / 2;

        const curTouch = { x: midpointX, y: midpointY };
        lastDoubleTouchPos.current = curTouch;

        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        const distance = Math.hypot(dx, dy);

        lastDistanceBetweenTouches.current = distance
    }

    const twoFingerTouchMove = (e: React.TouchEvent<HTMLCanvasElement>) => {
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];

        const midpointX = (touch1.clientX + touch2.clientX) / 2;
        const midpointY = (touch1.clientY + touch2.clientY) / 2;

        if (lastDoubleTouchPos.current) {
            const dx = midpointX - lastDoubleTouchPos.current.x;
            const dy = midpointY - lastDoubleTouchPos.current.y;

            const xBounds = 150;
            const yBounds = 400;

            if (CanvasDrawer.offset.x + dx < xBounds && CanvasDrawer.offset.x + dx > -xBounds) {
                CanvasDrawer.offset.x += dx;
            }

            if (CanvasDrawer.offset.y + dy < yBounds && CanvasDrawer.offset.y + dy > -yBounds) {
                CanvasDrawer.offset.y += dy;
            }

            if (!useStickerSectionStore.getState().hasPinched && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
                useStickerSectionStore.getState().setHasPinched(true);
            }
        }

        const curTouch = { x: midpointX, y: midpointY };
        lastDoubleTouchPos.current = curTouch;

        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        const distance = Math.hypot(dx, dy);

        if (lastDistanceBetweenTouches.current) {
            const diff = distance - lastDistanceBetweenTouches.current
            if (Math.sqrt((diff) ** 2) > 1) {

                const scaleIncrement = 750
                if (CanvasDrawer.scale + diff / scaleIncrement > 0.175 && CanvasDrawer.scale + diff / scaleIncrement < 1.1) {
                    let rect

                    if (CanvasDrawer.canvas) {
                        rect = CanvasDrawer.canvas.getBoundingClientRect();

                        const centerX = rect.width / 2;
                        const centerY = rect.height / 2;

                        const x1 = (midpointX - rect.left - centerX - CanvasDrawer.offset.x) / CanvasDrawer.scale;
                        const y1 = (midpointY - rect.top - centerY - CanvasDrawer.offset.y) / CanvasDrawer.scale;

                        CanvasDrawer.scale += diff / scaleIncrement;
                        const newScale = CanvasDrawer.scale;

                        CanvasDrawer.offset.x = midpointX - rect.left - centerX - x1 * newScale;
                        CanvasDrawer.offset.y = midpointY - rect.top - centerY - y1 * newScale;

                    }

                    if (!useStickerSectionStore.getState().hasZoomed) {
                        useStickerSectionStore.getState().setHasZoomed(true);
                    }


                }


            }

        }
        CanvasDrawer.rerenderCanvas()


        lastDistanceBetweenTouches.current = distance
    }

    const twoFingerTouchEnd = () => {
        lastDoubleTouchPos.current = null
        lastDistanceBetweenTouches.current = null
    }

    return { twoFingerTouchStart, twoFingerTouchMove, twoFingerTouchEnd }
}